import { Box, Switch, TextField, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import GenericDropdown from '../Intransit/GenericDropdown'
import { AttributeType } from '../../../constants/constants'

interface FieldsType {
    fields: any
    onChangeFields: any
    disabled?: boolean
}

const Fields = (props: FieldsType): ReactElement => {
    const { fields, onChangeFields, disabled } = props

    const { t } = useTranslation()

    return (
        <Box>
            {fields?.map((item: any) => {
                let inputComponent
                switch (item.dataType.toLowerCase()) {
                    case AttributeType.TEXT:
                        inputComponent = (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 2,
                                }}
                            >
                                <Typography
                                    sx={{ marginRight: '8px', width: '200px' }}
                                >
                                    {t(item.label)}
                                    {item.required ? '*' : ''}
                                </Typography>
                                <Box sx={{ width: '300px' }}>
                                    <TextField
                                        id={item.id}
                                        name={item.id}
                                        label={`${t(item.label)}${item.required ? '*' : ''}`}
                                        variant="outlined"
                                        value={item.value}
                                        onChange={(
                                            event: React.ChangeEvent<HTMLInputElement>,
                                        ) => {
                                            onChangeFields(
                                                item.id,
                                                event.target.value,
                                            )
                                        }}
                                        fullWidth
                                        error={item.errorMessage}
                                        disabled={disabled}
                                    />
                                </Box>
                            </Box>
                        )
                        break
                    case AttributeType.SELECT:
                        inputComponent = (
                            <GenericDropdown
                                id={item.id}
                                name={item.id}
                                label={t(item.label)}
                                value={item.value}
                                options={item.list}
                                isLoading={false}
                                onChange={(e) =>
                                    onChangeFields(item.id, e.target.value)
                                }
                                isMandatory={item.required}
                                hasError={item.errorMessage}
                                disabled={disabled}
                            />
                        )
                        break
                    case AttributeType.BOOLEAN:
                        inputComponent = (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 2,
                                }}
                            >
                                <Typography
                                    sx={{ marginRight: '8px', width: '200px' }}
                                >
                                    {t(item.label)}
                                </Typography>
                                <Box sx={{ width: '300px' }}>
                                    <Switch
                                        id={item.id}
                                        checked={item.value}
                                        disabled={disabled}
                                        onChange={(
                                            event: React.ChangeEvent<HTMLInputElement>,
                                        ) => {
                                            onChangeFields(
                                                item.id,
                                                event.target.checked,
                                            )
                                        }}
                                        inputProps={{
                                            'aria-label': 'Enable',
                                        }}
                                    />
                                </Box>
                            </Box>
                        )
                        break
                    default:
                        inputComponent = (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 2,
                                }}
                            >
                                <Typography
                                    sx={{ marginRight: '8px', width: '200px' }}
                                >
                                    {t(item.label)}
                                    {item.required ? '*' : ''}
                                </Typography>
                                <Box sx={{ width: '300px' }}>
                                    <TextField
                                        id={item.id}
                                        name={item.id}
                                        label={`${t('biDashboardId')}${item.required ? '*' : ''}`}
                                        variant="outlined"
                                        value={item.value}
                                        disabled={disabled}
                                        onChange={(
                                            event: React.ChangeEvent<HTMLInputElement>,
                                        ) => {
                                            onChangeFields(
                                                item.id,
                                                event.target.value,
                                            )
                                        }}
                                        fullWidth
                                        error={item.errorMessage}
                                    />
                                </Box>
                            </Box>
                        )
                }

                return inputComponent
            })}
        </Box>
    )
}

export default Fields
